export * from './AcquisitionStrategy';
export * from './ActualDataType';
export * from './AggregationMode';
export * from './AlarmLevel';
export * from './ApprovalStatus';
export * from './ConnectionPointType';
export * from './DashboardPeriod';
export * from './DataFolderOrigin';
export * from './DataType';
export * from './DateAlignment';
export * from './DateOrder';
export * from './DateTimeZone';
export * from './DayOfWeek';
export * from './DifferenceObjectType';
export * from './EmailEventType';
export * from './EventTrigger';
export * from './ExportMode';
export * from './GroupChangeType';
export * from './GroupDisplayName';
export * from './HeaderStyle';
export * from './IdentifierType';
export * from './JobStatus';
export * from './Limit';
export * from './lineStyles';
export * from './LogbookEntrySortOrder';
export * from './LogLevel';
export * from './multiSelects';
export * from './ObjectType';
export * from './PeriodReference';
export * from './PreviewMode';
export * from './PropertyType';
export * from './QualityId';
export * from './ReadType';
export * from './ResultStatus';
export * from './RowSpacing';
export * from './ScriptType';
export * from './SelectionStrategy';
export * from './SelectorType';
export * from './StepType';
export * from './TagRenamingStrategy';
export * from './TaskStatus';
export * from './TimePeriod';
export * from './TimeUnit';
export * from './TransactionStatus';
export * from './TrendLogbookEntriesType';
export * from './ValidationScope';
export * from './WiDEObjectType';
export * from './WorkflowType';

export enum Role {
    'User',
    'Admin',
    'Debug'
}

export enum FlatMode {
    Normal,
    NoDetection,
    InsideBounds,
    NoMinFlat,
    NoMaxFlat
}

export enum ErrorLevel {
    Info,
    Success,
    Warning,
    Error,
    Fatal
}

export enum TransactionType {
    Migration,
    Acquisition,
    Import,
    Encoding,
    ScriptExecution,
    StateComputation,
    DatabaseSynchronization
}

export enum ServiceStatus {
    Started,
    Stopped,
    Idle,
    Computing,
    Offline
}

export enum ScriptTestMode {
    DefaultValue,
    EndDateValue,
    MixedValue,
    BeginDateValue
}

export enum GroupConfigMode {
    ByType,
    ByGroup
}

export class EnumEx {
    static getNamesAndValues(e: Object) {
        return EnumEx.getNames(e).map(n => { return { name: n, value: <number>e[n] }; });
    }

    static getNames(e: Object) {
        return <string[]>EnumEx.getObjValues(e).filter(v => typeof v === 'string');
    }

    static getValues(e: Object) {
        return <number[]>EnumEx.getObjValues(e).filter(v => typeof v === 'number');
    }

    private static getObjValues(e: Object): (number | string)[] {
        return Object.keys(e).map(k => e[k]);
    }
}